import React from "react";
import { Col, FormGroup, Input } from "reactstrap";

/**
 * Array:text building block (SCRUM-553, VariableField registry) — the
 * multi-text-row editor. Emits the full string array via
 * `onChange(name, value)` (legacy handleTextArrayUpdate payload).
 *
 * Characterized quirk kept on purpose: an initial `[]` renders ZERO rows
 * until "+ Add Row" is clicked (only a non-array value falls back to one
 * empty row).
 */
export type ArrayTextFieldProps = {
  settingVar: { variable: string; value?: unknown };
  onChange: (name: string, value: string[]) => void;
};

export default function ArrayTextField({ settingVar, onChange }: ArrayTextFieldProps) {
  const arrayValue: string[] = Array.isArray(settingVar.value) ? settingVar.value : [""];

  const addRow = () => onChange(settingVar.variable, [...arrayValue, ""]);

  const deleteRow = () => {
    if (arrayValue.length > 1) {
      onChange(settingVar.variable, arrayValue.slice(0, -1));
    }
  };

  const updateText = (idx: number, newValue: string) => {
    const newArray = [...arrayValue];
    newArray[idx] = newValue;
    onChange(settingVar.variable, newArray);
  };

  return (
    <>
      <div className="text-center mb-3">
        <button
          type="button"
          className="btn btn-sm btn-outline-primary mr-2"
          onClick={addRow}
        >
          + Add Row
        </button>
        <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          onClick={deleteRow}
          disabled={arrayValue.length === 1}
        >
          - Delete Row
        </button>
      </div>
      <div>
        {arrayValue.map((value, idx) => (
          // index key: controlled row, no row-local state (SCRUM-2183)
          <FormGroup className="row" key={idx}>
            <Col md="2">
              <label style={{ color: "#597ade" }}>Text {idx + 1}</label>
            </Col>
            <Col md="10">
              <Input
                type="text"
                value={value || ""}
                onChange={(e) => updateText(idx, e.target.value)}
                placeholder={`Enter text ${idx + 1}`}
              />
            </Col>
          </FormGroup>
        ))}
      </div>
    </>
  );
}
